export enum PropertyBuildingUnitMixEnum {
  studio = 'studio',
  one_bedroom_one_bath = 'one_bedroom',
  two_bedroom_one_bath = 'two_bedroom',
  two_bedroom_two_bath = 'two_bedroom_two_bath',
  three_bedroom_two_bath = 'three_bedroom_two_bath',
  three_bedroom_three_bath = 'three_bedroom_three_bath',
  four_bedroom_two_bath = 'four_bedroom_two_bath',
  four_bedroom_three_bath = 'four_bedroom_three_bath',
  four_bedroom_four_bath = 'four_bedroom_four_bath',
}

export const PropertyBuildingUnitMixLabels = {
  [PropertyBuildingUnitMixEnum.studio]: 'Studio / 1BA',
  [PropertyBuildingUnitMixEnum.one_bedroom_one_bath]: '1 BD / 1BA',
  [PropertyBuildingUnitMixEnum.two_bedroom_one_bath]: '2 BD / 1BA',
  [PropertyBuildingUnitMixEnum.two_bedroom_two_bath]: '2 BD / 2BA',
  [PropertyBuildingUnitMixEnum.three_bedroom_two_bath]: '3 BD / 2BA',
  [PropertyBuildingUnitMixEnum.three_bedroom_three_bath]: '3 BD / 3BA',
  [PropertyBuildingUnitMixEnum.four_bedroom_two_bath]: '4 BD / 2BA',
  [PropertyBuildingUnitMixEnum.four_bedroom_three_bath]: '4 BD / 3BA',
  [PropertyBuildingUnitMixEnum.four_bedroom_four_bath]: '4 BD / 4BA',
}
